import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-self-serve }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/getting-started.hbs" })